import { images } from "../../assets/images";
const {
  
    Rewards,
    Profile,
   
    PropertySearch,
    Wallet,
    Share,
    Referral,
    People,
  } = images;
export const individualScreenData = [
    {
      name: "Onboarding",
      desc: "Elevate your rental property endeavors with our advanced SaaS digital infrastructure, synchronizing operations, finances, and management effortlessly",
      img: Profile,
    },
    {
      name: "Property discovery",
      desc: "Elevate your rental property endeavors with our advanced SaaS digital infrastructure, synchronizing operations, finances, and management effortlessly",
      img: PropertySearch,
    },
    {
      name: "Property sharing",
      img: Share,

      desc: "Elevate your rental property endeavors with our advanced SaaS digital infrastructure, synchronizing operations, finances, and management effortlessly",
    },
    {
      name: "Online referral ",
      img: Referral,
      desc: "Elevate your rental property endeavors with our advanced SaaS digital infrastructure, synchronizing operations, finances, and management effortlessly",
    },
    {
      name: "Earning wallet",
      img: Wallet,
      desc: "Elevate your rental property endeavors with our advanced SaaS digital infrastructure, synchronizing operations, finances, and management effortlessly",
    },
    {
      name: "Consultation",
      img: People,

      desc: "Elevate your rental property endeavors with our advanced SaaS digital infrastructure, synchronizing operations, finances, and management effortlessly",
    },
    {
      name: "Exciting offers and rewards",
      img: Rewards,

      desc: "Elevate your rental property endeavors with our advanced SaaS digital infrastructure, synchronizing operations, finances, and management effortlessly",
    },
   
  ];
 export const myList = [
    {
        ListNo : 1, Title:"Download the App", Desc:"Sit mauris habitasse blandit dictum dui aliquam quam quam scelerisque. Tempor ut hac sagittis feugiat."
    },
    {
        ListNo : 2, Title:"Engage with the platform", Desc:"Sit mauris habitasse blandit dictum dui aliquam quam quam scelerisque. Tempor ut hac sagittis feugiat."
    },
    {
        ListNo : 3, Title:"Collaborate with the properties", Desc:"Sit mauris habitasse blandit dictum dui aliquam quam quam scelerisque. Tempor ut hac sagittis feugiat."
    },
    {
        ListNo : 4, Title:"Generate Income", Desc:"Sit mauris habitasse blandit dictum dui aliquam quam quam scelerisque. Tempor ut hac sagittis feugiat."
    },
]